import script from "./EvidenciasView.vue?vue&type=script&setup=true&lang=js"
export * from "./EvidenciasView.vue?vue&type=script&setup=true&lang=js"

import "./EvidenciasView.vue?vue&type=style&index=0&id=675e7c8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675e7c8d"]])

export default __exports__